import React, { useEffect, useState } from "react";
import { storage as LocalStorage } from "services/config/storage";
import UserDefault from "assets/image/default_user_img.svg";
import * as userActions from "store/user/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Modal } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "./SelectProfile.scss";


const SelectProfile = ({ switchChild, onClose }) => {
    const [visible, setVisible] = useState(false);
    const [error, setError] = useState(null);

    let schoolLinkedProfiles = LocalStorage.fetch?.childData()?.list?.filter((child) => child.school_code !== null)

    useEffect(() => {
        const userLoggedIn = LocalStorage.fetch.authToken();
        const visited = sessionStorage.getItem("visited");
        const profileSelected = sessionStorage.getItem("profileSelected");

        const isReload =
            window.performance?.getEntriesByType("navigation")?.[0]?.type === "reload";

        if (userLoggedIn && ((profileSelected && !isReload) || (isReload && !profileSelected) || !isReload) && !visited) {
            setVisible(true);
        }
    }, []);

    const handleSelectProfile = async (id) => {
        setError(null);
        let res = await switchChild({ child_id: id });
        if (res?.success) {
            // localStorage.setItem("profileSelected",id)
            sessionStorage.setItem("visited", true);
            sessionStorage.setItem("profileSelected", true);
            setVisible(false);
            onClose()
            window.location.reload();
        } else {
            setError("Something went wrong. Please try again.");
        }
    };

    return (
        <Modal
            visible={visible}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <div className="select_profile_container">
                <p className="select_profile_heading">Welcome back!</p>
                <p className="select_profile_subheading">Who's reading with us today?</p>

                <Swiper
                    spaceBetween={20}
                    slidesPerView={2}
                    breakpoints={{
                        768: {
                            slidesPerView: Math.min(schoolLinkedProfiles?.length, 3),
                        },
                        0: {
                            slidesPerView: Math.min(schoolLinkedProfiles?.length, 3),
                        },
                    }}
                    // pagination={{ clickable: true }}
                    modules={[Navigation]}
                    navigation={true}
                    className="mySwiper swiperWhy"
                >
                    {schoolLinkedProfiles?.map((child) => (
                        <SwiperSlide key={child?.id} style={{ width: '20%' }}>
                            <div
                                className="user_profile_card"
                                onClick={() =>
                                    handleSelectProfile(child?.id)
                                }
                            >
                                <img
                                    src={child?.image}
                                    className="user_profile_image"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = UserDefault;
                                    }}
                                />
                                <p className="child_name">{child?.name}</p>
                                <p className="child_grade">{child?.grade?.name}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {error && <p className="error_text">{error}</p>}
            </div>
        </Modal>
    );
};

export default connect(
    ({ user }) => ({
        ...user,
    }),
    (dispatch) =>
        bindActionCreators(
            {
                ...userActions,
            },
            dispatch
        )
)(SelectProfile);
